/* eslint-disable complexity */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * 消息控制组件 已读未读，操作
 * @author sunzhiguang
 * @date 2020/6/10
 */
import React, { ReactNode, useCallback, useContext, useEffect, useMemo, useState } from "react";
import "./index.less";
import ChatState, { UserState } from "@/types/chat/State";
import {
  ChatMessage,
  Group,
  MessageStatus,
  ChatMessagePlusEmitBody,
  MessageEmitCategory,
  ImageChatMessage,
  JoySpaceDocumentMessage,
  UnifiedNoticeMessageEmitBody,
  NoticeMessageRespType,
  Employee,
  ClientType
} from "@/types/chat";
import { connect } from "dva";
import MessageOperate from "@/components/chat/message/Operate";
import { ClickParam } from "antd/lib/menu";
import ImService from "@/server/ImService";
import { message as toast } from "antd";
import IconFont from "@/components/icon";
import { useTranslation, WithTranslation, withTranslation } from "react-i18next";
import SessionType from "@jd/jdee.im.sdk/lib/es/enum/SessionType";
import {
  checkMessageSupport,
  employeeToUid,
  forwardJoySpaceCard,
  getMessageSendType,
  isCloudFileFunc,
  isEqualEmployee,
  buildGroupNoticeMessageBody,
  forwardLeaveWord,
  initChatMessageInfo,
  selectedSessionsToForward,
  voiceToTextFn,
  updateVoiceMessageReadStatus,
  isShowAlias,
  isCrossPlatformGroupSession,
  isOuterContacts,
  removeFirstOccurrence,
  forwardLimitSessionNum,
  openQuickReplyManual,
  sleep,
  sendReplyEmojiMessage,
  isOrgNoticeTextCardMessage,
  getOrgNoticeMultiMessageData,
  isOrgNoticeImageTextCardMessage,
  isOrgNoticeSingleImageTextMessage
} from "@/utils/chat/message";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { openUserSelectionDefaultModal } from "@/utils/modals";
import get from "lodash/get";
import isString from "lodash/isString";
import { UserModel } from "@/models/user";
import { SessionSettingsType } from "@/types/chat/enum";
import { ChatMessageType } from "@jd/jdee.im.sdk/lib/es/protocol/message/Type";
import TextMessageBody, { QuickReplyStatus } from "@jd/jdee.im.sdk/lib/es/protocol/message/Text";
import {
  addFileDownloadRecord,
  delMessageTag,
  getGroupMemberList,
  getProjectDetail,
  saveMessageTag
} from "@/api/chat";
import { isFocusEnv, FocusSDK, getClientType } from "@/utils";
import {
  openCreateSchedule,
  openCreateRemind,
  html2Canvas,
  getPreviewImageUrl,
  getImgSrc,
  isDocFileMessage
} from "@/utils/chat/index";
import { SelectorMode } from "@jd/focus-desktop-comps/lib/es/UserSelection";
import {
  ContactShowType,
  SelectGroupType,
  UserSelTab
} from "@jd/focus-desktop-comps/lib/es/UserSelection/types";
import Bus from "@/utils/bus";
import debounce from "lodash/debounce";
import CopyClipboard from "copy-to-clipboard";
import { cancelShareJoyspaceFiles, shareJoyspaceFiles } from "@/components/Joyspace/api/page";
import { deleteEmojiStr, getNewEmoji } from "@/components/chat/message/Input/Emoji";
import config, { ConfigEnum, getNetCheckUrl } from "@/config/config";
import chatConfig from "@/components/chat/config";
import DeeplinkEvent, { DeeplinkPathEnum } from "@/components/DeeplinkHandler/DeeplinkEvent";
import { shareScheduleAttachment } from "@/api/calendar";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { InputPlacement } from "@jd/focus-desktop-comps/lib/es/UserSelectionModal/types";
import { changeEgovUrl, getRealConfig } from "@/utils/tools";
import { getOriginMsg } from "@jd/jdee.im.sdk/lib/es/utils/utils";
import {
  queryNotificationDetail,
  createOrUpdateNotification,
  deleteNotification
} from "@/api/notification";
import { getGroupInfo } from "@/api/egroup";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import i18n from "@/i18n";
import DownloadService from "@/server/DownloadService";
import { deleteSolitaire } from "@/api/Solitaire";
import { isGifImage } from "../../utils/image";
import { analysisLog } from "@/utils/logAnalytics";
import { groupCreates } from "@/components/Joyspace/api";
import Context from "@/components/chat/context";
import { handleTransferTo } from "@/components/chat/message/Item/utils";
import AISummaryControl from "@/baseComponents/Chat/AISummaryControl";
import { checkFileIsExpired, getMessageEmojiHasReply } from "../../utils/commonMessageModal";
import { MessageExtAction } from "@jd/jdee.im.sdk/lib/es/protocol/messageExtend/Type";
import { omit } from "lodash";
interface MessageItemProps {
  messageNode: ReactNode;
  sendUserName: ReactNode;
  sendTime: React.ReactElement;
  headPortrait: ReactNode;
  message: ChatMessagePlusEmitBody & JoySpaceDocumentMessage;
  index: number;
  getCurrentMessageId: Function;
  setCurrentMessageId: Function;
  unLock: Function;
  getLock: (lock?: boolean) => boolean;
  showOperateBox: boolean;
  userData: UserModel;
  teamConfig: any;
  changeSelectMore: Function;
  updateSessionMessageMid: Function;
  updateSessionMessagesTimestamp: Function;
  isRightClick?: boolean;
  showAI?: boolean;
  saveAsCount: number;
  hasReachedMax?: boolean;
}

interface OwnState {
  showOperate: boolean;

}

interface DvaDispatchProps {
  deleteSessionMessage: (data: { message: ChatMessage }) => void;
  pushChatMessage: (data: { sessionId: string; message: Partial<ChatMessage> }) => void;
  pushChatMessageMid: (data: { sessionId: string; message: Partial<ChatMessage> }) => void;
  openCreateModal: Function;
  openCreateRemindModal: Function;
  setVoiceMessageMap: Function;
  updateSaveAsCount: Function;
  clearMessageBySession: Function;
  setStartMessageId: Function;
}

type IProps = Readonly<
  MessageItemProps & ChatState & DvaDispatchProps & UserState & WithTranslation
>;

function Control(props: IProps) {
  const {
    selectedSession,
    currentEmployee,
    message,
    allSessionList,
    showOperateBox,
    userData,
    teamConfig,
    deleteSessionMessage,
    pushChatMessage,
    pushChatMessageMid,
    changeSelectMore,
    updateSessionMessageMid,
    updateSessionMessagesTimestamp,
    isRightClick,
    voiceMessageMap,
    setVoiceMessageMap,
    showAI,
    saveAsCount,
    updateSaveAsCount,
    clearMessageBySession,
    setStartMessageId,
    quickReplys,
    hasReachedMax
  } = props;
  // console.log("Control===", hasReachedMax);
  
  const downloadServiceInstance = DownloadService.getInstance({});
  const { t } = useTranslation("chat");
  const { appRuntimeEnv, authInfo, imService } = useContext<GlobalContextConfig>(GlobalContext);
  const [showOperate, setShowOperate] = useState(false);
  const [sendStatus, setSendStatus] = useState(MessageStatus.INIT);
  const {
    groupRosters,
    groupRosterIdentity,
    isLLMAI,
    isMeetingChat,
    assistantAI,
    isSmall,
    currentFileControl
  } = React.useContext(Context);
  const { im } = appRuntimeEnv;
  const limit_session = getRealConfig(teamConfig, im, "forwardlimit_session") || 10;
  const limit_session_single = getRealConfig(teamConfig, im, "forwardlimit_session_single") || 20;
  // 操作更多的回调
  const operateMore = (visible: boolean) => {
    if (!visible) {
      props.unLock();
      const messageId = props.getCurrentMessageId();
      if (message.id === messageId) {
        return;
      }
      setShowOperate(false);
    } else {
      props.getLock(true);
    }
  };

  const copyToClipboard = (str: string) => {
    if (message?.quillJson?.length && !message?.plusList) {
      return CopyClipboard(str, {
        onCopy: (clipboard: any) => {
          clipboard.setData("text/plain", str);
          clipboard.setData("text/quill", JSON.stringify(message?.quillJson));
        }
      });
    } else {
      return CopyClipboard(str);
    }
  };

  const copyOperate = async (param: ClickParam) => {
    // 复制功能 --hujun
    props.unLock();
    if (message.type === ChatMessageType.TEXT) {
      let userSelection: any;
      const content =
        isShowAlias(selectedSession) && (message as any).atContent
          ? (message as any).atContent
          : message.content;
      let str = content;
      if (!str) return;
      if (typeof window.getSelection === "function") {
        const selectionObj: any = window.getSelection();
        if (selectionObj?.type === "None") {
          str = content;
        } else {
          const rangeObj = selectionObj?.getRangeAt(0);
          userSelection = rangeObj?.cloneContents();
          if (userSelection.childNodes.length === 0) {
            str = content;
          } else {
            const Selection = userSelection?.querySelectorAll("img");
            if (userSelection?.querySelectorAll(".message-box").length > 0) {
              str = content;
            } else {
              Selection?.forEach((item: any) => {
                let tempDiv = document.createElement("span");
                tempDiv.innerText = getNewEmoji(item.getAttribute("data-value") || "");
                userSelection?.replaceChild(tempDiv, item);
              });
            }
          }
        }
        // userSelection = window.getSelection();
      }
      // if (userSelection?.toString()) {
      //     str = userSelection.toString();
      //     console.log('复制成功', str);
      // }
      if (userSelection?.querySelectorAll(".message-box").length === 0) {
        str = userSelection?.textContent;
      }
      // if ((str || '').length > (message.content || '').length) {
      //     console.log('2', (str || '').length, (message.content || '').length);
      //     str = message.content;
      // }
      if (userSelection?.textContent.length === 0) {
        str = content;
      }
      if (message?.quillImage?.length) {
        str = removeFirstOccurrence(str, t("quill-old-version-tip"));
      }
      if (str && copyToClipboard(str)) {
        toast.success(t("copy-succeeded"));
      } else {
        toast.error(t("copy-failed"));
      }
    }
    // 复制图片 --caoxingzhuang
    if (message.type && message.type === ChatMessageType.IMAGE) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as ImageChatMessage,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type
      });
      if (isExpired) return;
      const Msg: any = message as ImageChatMessage;

      // let img: any = document.querySelector(`[data-id="${message.id}"]`);
      // let searchParams: any;
      // if (img) {
      //   searchParams = img.cloneNode(true);
      //   searchParams.id = "img-clone";
      //   searchParams.style.zIndex = "-1";
      //   searchParams.width = Msg.width / 2;
      //   searchParams.height = Msg.height / 2;
      //   searchParams.src = changeEgovUrl(getPreviewImageUrl(Msg.url, true));
      //   document.body.appendChild(searchParams);
      // }
      // const timer = setTimeout(() => {
      //   if (searchParams) {
      //     html2Canvas(searchParams, true)
      //       .then((url) => {
      //         let isOk = FocusSDK.clipboardImage(url);
      //         isOk ? toast.success(t("copy-succeeded")) : toast.error(t("copy-failed"));
      //       })
      //       .catch(() => {
      //         toast.error(t("copy-failed"));
      //       })
      //       .finally(() => {
      //         document.body.removeChild(searchParams);

      //         searchParams = null;
      //       });
      //   } else {
      //     toast.error(t("copy-failed"));
      //   }
      //   clearTimeout(timer);
      // }, 60);
      const url =
        isGifImage(Msg.url) || Msg.size < 1024 * 1024
          ? getImgSrc(Msg.url)
          : getPreviewImageUrl(Msg.url, false);
      FocusSDK.getImageDataFromServer(url, (data: any) => {
        if (data?.code === 0) {
          let img: any = document.querySelector(`[data-id="${message.id}"]`);
          if (img) {
            const image_bck = img.cloneNode(true) as HTMLElement;
            document.body.appendChild(image_bck);
            image_bck.setAttribute("src", changeEgovUrl(data.result));
            image_bck.setAttribute("id", "img-clone");
            image_bck.style.zIndex = "-1";
            html2Canvas(image_bck, true)
              .then(async (url) => {
                let isOk = await FocusSDK.clipboardImage(url);
                isOk ? toast.success(t("copy-succeeded")) : toast.error(t("copy-failed"));
              })
              .catch(() => {
                toast.error(t("copy-failed"));
              })
              .finally(() => {
                document.body.removeChild(image_bck);
              });
          }
        } else {
          toast.error(t("copy-failed"));
        }
      });
    }
    if ((message.type as any) === NoticeMessageRespType.UNIFIED_NOTICE_MESSAGE) {
      const msg: any = { ...message };
      if (!msg?.extend) {
        return;
      }
      let str = `【${msg?.extend?.applicationName || "应用"}】${msg.title}`;
      const el = document.getElementById(`notice-card-id-${message.id}`);
      const items = el?.querySelectorAll(".content_item");
      if (!items) {
        return;
      }
      str = Array.from(items).reduce((a: string, b: any) => {
        const label = b.querySelector(".content_item_label");
        const text = b.querySelector(".content_item_value");
        return `${a}\r\n${label?.textContent}${text?.textContent}`;
      }, str);
      if (str && CopyClipboard(str)) {
        toast.success(t("copy-succeeded"));
      } else {
        toast.error(t("copy-failed"));
      }
    }
  };
  const revoke_joysapce = () => {
    let users: Array<any> = [];
    let groups: Array<any> = [];
    const info = selectedSession.info;
    if (!selectedSession.isGroup) {
      users.push({
        // @ts-ignore
        userId: info.userId,
        // @ts-ignore
        teamId: info.teamId,
        permission_type: 2
      });
    } else {
      groups.push({
        // @ts-ignore
        gid: info?.gid || "",
        permission_type: 2
      });
    }
    cancelShareJoyspaceFiles({
      // @ts-ignore
      page_ids: [message?.fileId || ""],
      to_eepaas_users: users,
      to_groups: groups
    });
  };
  const revokeOperate = async (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    // 改为根据本地发送的时间戳计算是否符合撤回的条件
    // if (Date.now() - message.timestamp > 2 * 60 * 1000) {
    if (!message.localSendTimestamp) return;
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
    }
    // 消息（文本)撤回时间 如果ducc读取不到 默认是两小时
    const revoketime_text = im.chatRevokeTime || 7200000;
    // 文件、图片、视频类型的消息撤回时间 默认是24小时
    const revoketime_file = im.chatRevokeTime2 || 86400000;
    const expireTime =
      message.type === ChatMessageType.FILE ||
        message.type === ChatMessageType.IMAGE ||
        message.type === ChatMessageType.EGOV_FILE ||
        message.type === ChatMessageType.VIDEO
        ? revoketime_file
        : revoketime_text;
    // console.log(
    //     '撤回时间判断',
    //     new Date(),
    //     new Date(message.localSendTimestamp),
    //     new Date().getTime() - message.localSendTimestamp,
    //     expireTime,
    //     new Date().getTime() - message.localSendTimestamp > expireTime
    // );
    if (new Date().getTime() - message.localSendTimestamp <= 0) {
      console.log("当前时间小于消息发送的时间，可能手动改了系统时间");
      return;
    }
    if (new Date().getTime() - message.localSendTimestamp > expireTime) {
      // 不能撤回超过几分钟的消息
      toast.error(t("recall-message-reminder"));
      return;
    }
    // TODO 显示加载中
    const imService = ImService.getInstance();
    const result = await imService.revokeMessage(selectedSession, message);
    if (result) {
      // @ts-ignore
      if (message.type === ChatMessageType.JOYSPACEFILE) {
        revoke_joysapce();
      }
      if (message.type === ChatMessageType.GROUPNOTICE) {
        let notificationMsg: any = message;
        deleteNotification({
          notificationId: notificationMsg.notificationId
        });
      }
      if (message.type === ChatMessageType.SOLITAIRE) {
        let solitaireMsg: any = message;
        deleteSolitaire({
          solitaireId: solitaireMsg.solitaireId
        });
      }
      toast.success(t("withdrawal-successful"));
    } else {
      toast.error(t("withdrawal-failed"));
    }
    // TODO 取消加载中
  };
  const adminRevoke = (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    const adminRevokeTime = im.adminRevokeTime || 864000000;
    prompt({
      title: t("admin revoke title"),
      content: <p style={{ color: "#ED6A0C" }}>{t("admin revoke content")}</p>,
      cancelText: t("cancelText"),
      okText: t("determine"),
      onOk: async () => {
        if (!message.localSendTimestamp) return;
        if (new Date().getTime() - message.localSendTimestamp <= 0) {
          return;
        }
        if (new Date().getTime() - message.localSendTimestamp > adminRevokeTime) {
          toast.error(t("recall-message-reminder-admin"));
          return;
        }
        const imService = ImService.getInstance();
        const result = await imService.revokeMessage(selectedSession, message, 1);
        if (result) {
          // @ts-ignore
          if (message.type === ChatMessageType.JOYSPACEFILE) {
            revoke_joysapce();
          }
          toast.success(t("withdrawal-successful"));
        } else {
          toast.error(t("withdrawal-failed"));
        }
      },
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />
    });
  };
  // 聚合消息撤回
  const revokeMsgOperate = async (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    let times: any;
    let Msg: any = message;
    message.plusList?.map((item: any, index: any) => {
      // Msg.mid = item.messageId;
      times = item.timestamp;
    });
    if (new Date().getTime() - times > im.chatRevokeTime) {
      // 不能撤回超过几分钟的消息
      toast.error(t("recall-message-reminder"));
      return;
    }
    let messageId: any;
    // eslint-disable-next-line array-callback-return
    Msg.plusList.filter((user: any, index: any) => {
      if (currentEmployee.userId === user.userId && user.statusType === MessageStatus.SUCCESS) {
        messageId = user.messageId;
      }
    });
    // TODO 显示加载中
    const imService = ImService.getInstance();
    const result = await imService.revokeMergedMessage(
      selectedSession.sessionId,
      messageId,
      Msg.mid,
      {
        plusList: message.plusList as any
      }
    );
    if (result) {
      if (message.plusList?.length) {
        const revokes = message.plusList.filter((i) => i.statusType !== MessageStatus.REVOKE);
        message.revoke = revokes.length === 0 ? 1 : 0;
      }
      updateSessionMessageMid({
        sessionId: message.sessionId,
        sendResult: { body: { ...message, plusList: Msg.plusList } }
      });
      toast.success(t("withdrawal-successful"));
    } else {
      toast.error(t("withdrawal-failed"));
    }
  };
  const forwardOperate = (param?: ClickParam) => {
    props.unLock();
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
    }
    // const fixedUsers = getSelectorSessions(allSessionList);
    const filterUsers =
      message.type === ChatMessageType.GROUPNOTICE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.JOYSPACEFILE ||
      message.type === ChatMessageType.JOYSPACEFOLDER ||
      message.type === ChatMessageType.LOCATION_JD ||
      (message.type === ChatMessageType.TEMPLATE2
        ? message?.template.nativeId === "share_link" &&
        DeeplinkEvent.parseDeeplink(message?.data[0].sharelink?.url).pathname === DeeplinkPathEnum.Task_Draw
        : false);
    openUserSelectionDefaultModal(
      {
        title: t("select-session-contacts"),
        // fixedUsers: fixedUsers,
        frozenIds: [],
        currentUser: employeeToUid(currentEmployee),
        // mode: SelectorMode.forward,
        mode: SelectorMode.user,
        tabs: ["recentIncludeGroup", "groupCanBeSel"],
        tabSort: [{ tab: UserSelTab.recentIncludeGroup, sort: 1 }],
        leaveWordInput: {
          maxLength: chatConfig["forward-leave-max-length"],
          placeholder: t("please-enter-forward-leave"),
          isTextArea: true
        },
        inputPlacement: InputPlacement.bodyRightBottom,
        inputWrapClass: "forward-input-wrap",
        contactShowType: filterUsers ? ContactShowType.multiTenement : ContactShowType.all,
        selectGroupType: filterUsers ? SelectGroupType.innerAndCrossTenement : SelectGroupType.all,
        maxSelectedNum: limit_session,
        maxSelectedSingleNum: limit_session_single,
        isForwardMode: true,
        validate(data) {
          return new Promise((resolve, reject) => {
            let list = get(data, "data.result", []);
            const canForward = forwardLimitSessionNum(list, limit_session, limit_session_single);
            if (!canForward) {
              toast.warning(`最多支持选择${limit_session_single}个单聊，${limit_session}个组沟通`);
              return;
            }
            // if (list.length > limit_session) {
            //   toast.error(`最多支持选择${limit_session}个会话`);
            //   return false;
            // }
            const forwardLeave = get(data, "data.leaveWordInputValue", "");
            if (forwardLeave && forwardLeave.length > chatConfig["forward-leave-max-length"]) {
              toast.info(
                t("content over maxLength", {
                  name: "留言",
                  maxLength: chatConfig["forward-leave-max-length"]
                })
              );
              return false;
            }
            if (message.type === ChatMessageType.GROUPNOTICE) {
              // eslint-disable-next-line array-callback-return
              let isGroups = list.map((item: any) => {
                if (item.isGroup !== true) {
                  return "false";
                }
              });
              if (isGroups.includes("false")) {
                toast.error("组通知不支持转发给单人");
                // eslint-disable-next-line prefer-promise-reject-errors
                reject("组通知不支持转发给单人");
                return;
              }
              // ForWardGroupTz(list);
            }
            resolve();
          });
        }
      },
      (data, close) => {
        doExitAndForward(data, close);
      },
      userData
    );
  };
  const exitAndForward = (options: any, list: any): Promise<boolean> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      const imService = ImService.getInstance();
      const sessionId = selectedSession.sessionId;
      if (message.type === ChatMessageType.GROUPNOTICE) {
        list.forEach(async (item: any, index: any) => {
          if (item.isGroup !== true) {
            return;
          }
          const groups = await getGroupInfo({
            groupIds: [{ groupId: item.sessionId || item.gid || item.id }]
          });
          const isOutOfGroup = groups.groups[0].flag !== 3;
          const isDisband = groups.groups[0].status === 0;
          if (isOutOfGroup || isDisband) {
            let isgroup = "false";
            if (isgroup.includes("false")) {
              resolve(false);
              return;
            }
          }
          ForWardGroupTz(item);
          resolve(true);
        });
        return;
      }
      let Msg: any = message;
      message.plusList?.map((item: any) => {
        if (item.statusType === MessageStatus.SUCCESS) {
          Msg.mid = item.messageId;
        }
      });
      // 转发文档或者文件夹授权
      let body: any = await forwardJoySpaceCard(message, options, message.type);
      // console.log(body, 'bodybodybodybodybod=====>', message);
      // 转发文档授权
      // if (message.type === ChatMessageType.JOYSPACEFILE) {
      //     // @ts-ignore
      //     // @ts-ignore
      //     // const byMessage = await imService.getBySession(message.sessionId, message.mid);
      //     const pageId = (message as any).fileId;
      //     const joyspacePageIds = [pageId];
      //     let users: Array<any> = [];
      //     (options?.uids || []).forEach((user: any) => {
      //         users.push({
      //             userId: user.pin,
      //             teamId: user.teamId,
      //             // @ts-ignore
      //             permission_type: 2,
      //         });
      //     });
      //     let groups: Array<any> = [];
      //     (options?.gids || []).forEach((id: any) => {
      //         // @ts-ignore
      //         groups.push({
      //             gid: id,
      //             permission_type: 2,
      //         });
      //     });
      //     const res = await shareJoyspaceFiles({
      //         page_ids: joyspacePageIds,
      //         to_eepaas_users: users,
      //         to_groups: groups,
      //     });
      //     const isDelPage = !Array.isArray(res[pageId].page.permissions);
      //     body = {
      //         currentPermission: isDelPage ? -1 : 2,
      //         permission: isDelPage ? -1 : (message as any).permission,
      //     };
      // }
      // 组织号文本卡片消息
      if (isOrgNoticeTextCardMessage(message)) {
        const dataInfo = getOrgNoticeMultiMessageData(message);
        body = {
          ...body,
          content: dataInfo?.content,
          type: ChatMessageType.TEXT,
          subType: ChatMessageType.TEXT
        };
      }
      // 组织号单图文片消息
      if (isOrgNoticeSingleImageTextMessage(message)) {
        const dataInfo = getOrgNoticeMultiMessageData(message);
        dataInfo.orgAvatar = message?.sender?.avatar;
        dataInfo.orgName = message?.sender?.name;
        body = {
          ...body,
          data: [dataInfo]
        };
      }
      const result = await imService.forwardMessage(sessionId, Msg, options, body);
      if (isString(result) && result === SessionSettingsType.BANNED_POST) {
        // return toast.warn(t('banned_post_tip'));
        toast.warn(t("banned_post_tip"));
        resolve(false);
      }
      if (result) {
        if (Msg.template?.nativeId === "share_link") {
          if (Msg.data[0].sharelink.url) {
            const parseUrl = DeeplinkEvent.parseDeeplink(Msg.data[0].sharelink.url);
            if (
              parseUrl?.pathname === DeeplinkPathEnum.Task_Draw ||
              parseUrl?.pathname === DeeplinkPathEnum.Schedule_Draw
            ) {
              const { mparam } = parseUrl;
              const bizId =
                parseUrl?.pathname === DeeplinkPathEnum.Task_Draw
                  ? mparam?.taskId
                  : mparam?.scheduleId;
              const bizType = parseUrl?.pathname === DeeplinkPathEnum.Task_Draw ? 1 : 2;
              shareScheduleAttachment({
                bizId: bizId,
                bizType: bizType,
                shareRecipientDtos: list.map((item: any) => {
                  if (item.isGroup) {
                    return {
                      recipientType: "2",
                      recipientId: item.id,
                      recipientName: item.name
                    };
                  } else {
                    return {
                      recipientType: "1",
                      recipientId: item.pin,
                      recipientName: item.name,
                      teamId: item.teamId,
                      app: item.app
                    };
                  }
                })
              });
            }
          }
        }
        // toast.success(t('forwarding-successful'));
        resolve(true);
      } else {
        resolve(false);
        // toast.error(t('forwarding-failed'));
      }
    });
  };

  // 转发组通知
  const ForWardGroupTz = async (item: any) => {
    if (message.type === ChatMessageType.GROUPNOTICE) {
      let groupMsg: any = message;
      const instance = ImService.getInstance();
      const newDate = new Date().getTime();
      const datas = buildGroupNoticeMessageBody({
        content: groupMsg.content,
        currentEmployee,
        data: {
          optionList: groupMsg.optionList,
          notificationId: "",
          attachmentList: groupMsg.attachmentList,
          creatorName:
            currentEmployee.name || authInfo?.teamUserInfo?.realName || authInfo?.realName,
          creatorUserId: currentEmployee.userId,
          userList: [
            {
              pin: currentEmployee.userId,
              name: currentEmployee.name || authInfo?.teamUserInfo?.realName || authInfo?.realName,
              teamId: currentEmployee.teamId,
              app: currentEmployee.app,
              optionId: "",
              timestamp: newDate
            }
          ]
        }
      });
      const messageOpts = await instance?.getMessageOptions();
      datas.id = messageOpts.id;
      // list.forEach(async (item: any) => {
      const messages = {
        ...messageOpts,
        body: { ...datas },
        gid: item.sessionId || item.gid || item.id,
        type: MessageEmitCategory.CHAT_MESSAGE
      };
      if (groupMsg.attachmentList) {
        groupMsg.attachmentList.forEach((files: any) => {
          const filetype = files.fileType.substring(0, 8);
          if (filetype !== "joyspace") return;
          shareJoyspaceFiles({
            page_ids: [files.fileId],
            to_eepaas_users: [],
            to_groups: [
              {
                gid: item.sessionId || item.gid || item.id,
                permission_type: 2
              }
            ]
          });
        });
      }
      await createOrUpdateNotification({
        notificationId: "",
        content: groupMsg.content,
        sourceType: 1,
        sourceBizId: item.sessionId || item.gid || item.id,
        status: 0,
        messageId: datas.id,
        optionList: groupMsg.optionList,
        attachmentList: groupMsg.attachmentList,
        groupChatMessage: messages
      })
        .then()
        .catch((err) => {
          console.log(err);
        });
      // });
    }
  };

  const doExitAndForward = debounce(async (data: any, close) => {
    // 等待消息转发完成以后关闭窗口
    const list = get(data, "data.result", []);
    if (!list || list.length <= 0) {
      return;
    }
    const options = await selectedSessionsToForward(list);
    console.log(list, options, 7777);
    const status = await exitAndForward(options, list);
    if (status) {
      const forwardLeave = get(data, "data.leaveWordInputValue", "");
      // console.log(forwardLeave);
      forwardLeave && (await forwardLeaveWord(currentEmployee, options, forwardLeave));
      toast.success(t("forwarding-successful"));
    } else if (message.type === ChatMessageType.GROUPNOTICE && !status) {
      toast.error("该组已解散");
    } else {
      toast.error(t("forwarding-failed"));
    }
    close();
  }, 500);

  const selectMoreFn = () => {
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
    }
    changeSelectMore({ selectMore: true });
    props.unLock();
  };

  // 唤起日程创建
  const scheduleOperate = async (param: ClickParam) => {
    props.unLock();
    // this.setState({ showOperate: false });
    setShowOperate(false);
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
    }
    const isCreateMessageType = [
      ChatMessageType.TEXT,
      ChatMessageType.FILE,
      ChatMessageType.IMAGE
    ].includes(message.type as any);
    if (isCreateMessageType || isCloudFileFunc(message)) {
      analysisLog("xtbg_calhome_1640073907694", "45");
      const params: any = {
        messageResource: message.type !== ChatMessageType.TEXT ? message : null,
        selectedSession: selectedSession
      };
      let title = (message as TextMessageBody).content;
      if (message?.quillImage?.length) {
        title = removeFirstOccurrence(title, t("quill-old-version-tip"));
      }
      title = deleteEmojiStr(title);
      if (selectedSession.isGroup) {
        const { businessId, business } = selectedSession.info as Group;
        if (business && business?.indexOf("project") > -1) {
          // 专班群
          const [data, error] = await getProjectDetail({
            projectId: businessId,
            summary: true
          });
          if (data.calendarId) {
            if (isFocusEnv()) {
              openCreateSchedule({
                title: message.type === ChatMessageType.TEXT ? title : "",
                calendarId: data.calendarId,
                ...params
              });
            } else {
              props.openCreateModal({
                visible: true,
                title: message.type === ChatMessageType.TEXT ? title : "",
                frozenCalendarId: data.calendarId,
                ...params
              });
            }
            return;
          }
        }
      }
      if (selectedSession.isSingle) {
        const {
          app,
          userId,
          teamId,
          labelInfoList,
          name: realName,
          avatar,
          employeeExt,
          unitName,
          deptName,
          titleName
        } = selectedSession.info as Employee;
        params.participant = [
          {
            app,
            ddAppId: app,
            userId,
            teamId,
            realName,
            headImg: avatar,
            labelInfoList,
            titleName: `${unitName ? unitName + "-" : ""}${deptName ? deptName + "-" : ""}${
              titleName || ""
            }`,
            userType: employeeExt?.userType
          }
        ];
      }
      if (isFocusEnv()) {
        props.openCreateModal({
          visible: true,
          title: message.type === ChatMessageType.TEXT ? title : "",
          calendarId: "",
          ...params
        });
      } else {
        props.openCreateModal({
          visible: true,
          title: message.type === ChatMessageType.TEXT ? title : "",
          frozenCalendarId: "",
          ...params
        });
      }
    }
  };

  // 唤起任务创建
  const taskOperate = async (param: ClickParam) => {
    props.unLock();
    // this.setState({ showOperate: false });
    setShowOperate(false);
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
    }
    const isCreateMessageType = [
      ChatMessageType.TEXT,
      ChatMessageType.FILE,
      ChatMessageType.IMAGE,
      ChatMessageType.GROUPNOTICE
    ].includes(message.type as any);
    if (isCreateMessageType || isCloudFileFunc(message)) {
      if (selectedSession.isGroup) {
        const { businessId, business, name } = selectedSession.info as Group;
        if (message.type === ChatMessageType.GROUPNOTICE) {
          const [data, err] = await queryNotificationDetail({
            notificationId: (message as any).notificationId
          });
          let allMember = [].concat(
            data.readMemberList[0]?.memberList || [],
            data.unReadMemberList
          );
          // debugger; // eslint-disable-line
          analysisLog("xtbg_add_task", "xtbg_add_task_createtask_source1");
          Bus.emit("task:open-create", {
            title: "",
            content: (message.content || "").substring(0, 500),
            messageResourceArr: (message as any)?.attachmentList,
            sourceName: name,
            selectedSession,
            groupNoticeReadingMemberList: allMember
          });
        } else if (business && business?.indexOf("project") > -1) {
          let title = (message as TextMessageBody).content;
          title = deleteEmojiStr(title);
          analysisLog("xtbg_add_task", "xtbg_add_task_createtask_source1");
          Bus.emit("task:open-create", {
            title: message.type === ChatMessageType.TEXT ? title : "",
            messageResource: message.type !== ChatMessageType.TEXT ? message : null,
            projectId: businessId,
            sourceName: name,
            selectedSession
          });
        } else {
          let title = (message as TextMessageBody).content;
          if (message?.quillImage?.length) {
            title = removeFirstOccurrence(title, t("quill-old-version-tip"));
          }
          title = deleteEmojiStr(title);
          analysisLog("xtbg_add_task", "xtbg_add_task_createtask_source1");
          Bus.emit("task:open-create", {
            title: message.type === ChatMessageType.TEXT ? title : "",
            messageResource: message.type !== ChatMessageType.TEXT ? message : null,
            projectId: "",
            sourceName: "",
            selectedSession
          });
        }
        return;
      }
      let title = (message as TextMessageBody).content;
      if (message?.quillImage?.length) {
        title = removeFirstOccurrence(title, t("quill-old-version-tip"));
      }
      title = deleteEmojiStr(title);
      analysisLog("xtbg_add_task", "xtbg_add_task_createtask_source2");
      Bus.emit("task:open-create", {
        title: message.type === ChatMessageType.TEXT ? title : "",
        messageResource: message.type !== ChatMessageType.TEXT ? message : null,
        projectId: "",
        sourceName: "",
        selectedSession
      });
    }
  };

  // 唤起提醒创建
  const remindOperate = async (param: any) => {
    props.unLock();
    // this.setState({ showOperate: false });
    setShowOperate(false);
    if (message.type === ChatMessageType.TEXT) {
      let title = (message as TextMessageBody).content;
      if (message?.quillImage?.length) {
        title = removeFirstOccurrence(title, t("quill-old-version-tip"));
      }
      title = deleteEmojiStr(title);
      if (isFocusEnv()) {
        openCreateRemind({
          selectedSession: selectedSession,
          createData: { content: title, from: "IM" }
        });
      } else {
        props.openCreateRemindModal({
          visible: true,
          selectedSession: selectedSession,
          createData: { content: title, from: "IM" }
        });
      }
    }
  };

  const deleteOperate = (param: ClickParam) => {
    props.unLock();
    // this.setState({ showOperate: false });
    setShowOperate(false);
    // 删除提醒
    prompt({
      title: t("delete-reminder"),
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      onOk: async () => {
        // 设用删除接口
        const imService = ImService.getInstance();
        const result = await imService.deleteMessage(message);
        if (result) {
          // 删除 dva 中的 数据
          deleteSessionMessage({ message });
          toast.success(t("deletion-succeeded"));
          // window.location.reload();
        } else {
          toast.error(t("deletion-failed"));
        }
      },
      content: t("delete-selected-message"),
      okText: t("determine"),
      cancelText: t("cancelText")
    });
  };

  const handleSkipRawMsg = (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    // 获取定位消息
    if (message.replyMsgs?.length) {
      const rawMsg: any = message.replyMsgs[0];
      if (rawMsg?.statusType === MessageStatus.DELETE) {
        // 删除
        toast.error(t("reply-skip-error"));
        return;
      }
      setStartMessageId({
        sMid: message.mid,
        sText: "",
        skipAnchorId: {}
      });
      sleep(60).then(() => {
        setStartMessageId({
          sMid: rawMsg?.mid,
          sText: rawMsg?.content,
          sTimestamp: rawMsg?.timestamp,
          skipAnchorId: {
            msgId: message.id,
            skipId: rawMsg?.id || ""
          }
        });
      });
    }
  };

  const getContent = () => {
    return (
      <span style={{ display: "flex", flexDirection: "column" }}>
        <span>{t("destroy-selected-message")}</span>
        <span style={{ color: "#999999" }}>{t("destroy-selected-message_child")}</span>
      </span>
    );
  };

  // 单条消息销毁
  const destroyOperate = (param: ClickParam) => {
    props.unLock();
    // this.setState({ showOperate: false });
    setShowOperate(false);
    // 销毁提醒
    prompt({
      title: t("destroy-reminder"),
      icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
      onOk: async () => {
        const imService = ImService.getInstance();
        const result = await imService.destroyMessage(message);
        if (result) {
          // 删除 dva 中的 数据
          // deleteSessionMessage({ message });
          toast.success(t("destroyed-succeeded"));
        } else {
          toast.error(t("destroyed-failed"));
        }
      },
      content: getContent(),
      okText: t("determine"),
      cancelText: t("cancelText")
    });
  };
  const netServer = NetworkCheck.getInstance({
    url: getNetCheckUrl(),
    checkType: UseCheckType.API
  });
  // 文件另存为
  const handleFile = async (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    const onLine = await netServer.checkNet();
    if (!onLine) {
      return toast.error(i18n.t("Network Error"));
    }
    if (
      message.type === ChatMessageType.FILE ||
      message.type === ChatMessageType.EGOV_FILE ||
      message.type === ChatMessageType.IMAGE ||
      message.type === ChatMessageType.VIDEO
    ) {
      const isExpired = checkFileIsExpired({
        // expiredAppKey: imAppKey,
        message: message as any,
        updateSessionMessageMid,
        expiredTime: im.fileExpiredTime,
        type: message.type === ChatMessageType.EGOV_FILE ? "file" : message.type
      });
      if (isExpired) return;
      if (!FocusSDK.isPrivateNet() && message.type === ChatMessageType.EGOV_FILE) {
        toast.error(t("egov-file-notice"));
        return;
      }
      downloadServiceInstance.download(
        {
          viewFile: false,
          saveAs: true,
          message,
          auto: false
        },
        {
          onStarted: () => {
            console.log("rightClick");
            updateSaveAsCount(saveAsCount + 1);
          },
          onProgress: () => { },
          onCancel: () => { },
          onPause: () => { },
          onResume: () => { },
          onFinish: async (file: { path: string; filename: string }, data: any) => {
            toast.success("下载成功");
            localStorage.setItem("downloadFilePath", data.saveAs);
            const path = file.path;
            const imservice = ImService.getInstance();
            const result = await imservice.updateLocalPath(message.sessionId, message.mid, {
              downLocalPath: path
            });
            if (result) {
              await updateSessionMessageMid({
                sessionId: message.sessionId,
                sendResult: { body: { ...message, downLocalPath: path } }
              });
              await updateSessionMessagesTimestamp({
                timestamp: new Date().getTime()
              });
            }
            if (
              !isEqualEmployee(message.sender, currentEmployee) &&
              message.type === ChatMessageType.FILE
            ) {
              addFileDownloadRecord({
                fileId: message.id,
                fileName: (message as any).name,
                fileUrl: (message as any).url,
                groupId: selectedSession.isGroup ? selectedSession.sessionId : undefined,
                mid: message.mid,
                senderUserId: message.sender.userId,
                senderTeamId: message.sender.teamId,
                senderApp: message.sender.app,
                optType: 0
              }).then((res) => {
                console.log(res, "addFileDownloadRecord");
              });
            }
          },
          onError: (error: any) => {
            console.log("error=>", error);
            if (error.errorCode === 1017005) {
              const imService = ImService.getInstance();
              imService.updateMessage(message.sessionId, message.mid, {
                statusType: MessageStatus.EXPIRED
              });
              updateSessionMessageMid({
                sessionId: message.sessionId,
                sendResult: { body: { ...message, statusType: MessageStatus.EXPIRED } }
              });
            }
          }
        }
      );
    }
  };

  // 创建组空间
  const groupCreate = useCallback(async () => {
    const { name } = selectedSession.info as any;
    const owner = (selectedSession as any)?.info || {};
    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
      return;
    }
    let groupList = groupRosters;
    try {
      if (Array.isArray(groupList) && !groupList.length) {
        const { data, groupId } = await getGroupMemberList(
          (selectedSession as any)?.info.gid,
          "group"
        );
        groupList = data || [];
      }
      console.log("群信息", groupList);
      if (!groupList.length) {
        toast.error("该群已解散");
        return;
      }
      let gid = owner.gid;
      let gname = owner.name;
      let description = owner.intro;
      let admins: any = [];
      for (let item of groupList) {
        if (item.identity === "administrator" || item.identity === "sub_administrator") {
          admins.push((item as any).info.userId);
        }
      }
      let result = await groupCreates({
        admins,
        folderId: gid,
        name: gname,
        description,
        parent: "groupRoot"
      });
      if (!result || result.errMsg) {
        toast.error("create_group_team_space_error");
      }
    } catch (e) {
      e && toast.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupRosters]);

  // 文件转存到文档协同/组空间
  const handleFileTo = async (param: ClickParam) => {
    props.unLock();
    setShowOperate(false);
    const onLine = await netServer.checkNet();
    if (!onLine) {
      return toast.error(i18n.t("Network Error"));
    }
    const isExpired = checkFileIsExpired({
      // expiredAppKey: imAppKey,
      message: message as any,
      updateSessionMessageMid,
      expiredTime: im.fileExpiredTime
    });
    if (isExpired) return;
    handleTransferTo(
      message,
      selectedSession,
      currentEmployee,
      groupCreate,
      appRuntimeEnv,
      userData,
      updateSessionMessageMid
    );
  };

  // 消息组标记
  const handleMsgTag = async () => {
    props.unLock();
    const onLine = await netServer.checkNet();
    if (!onLine) {
      return toast.error(i18n.t("Network Error"));
    }
    let { userId, teamId, unitName, unitDeptId, name } = message.sender;
    let { timestamp, content, mid, sessionId, id } = message;
    if (message.plusList) {
      mid = message.plusList[0].messageId;
      unitName = message.plusList[0].unitName;
    }
    if (message?.tag === 1) {
      const [data, error] = await delMessageTag({
        delMessageTags: [
          {
            mid: `${mid}`,
            uuid: id,
            deviceCode: message?.deviceCode
          }
        ],
        groupId: sessionId
      });
      if (error) {
        toast.warn(error);
      } else {
        toast.success(t("tag-cancel"));
      }
    } else {
      const ext = getOriginMsg(message);
      if (!ext) {
        toast.warn(t("tag-failed"));
        return;
      }
      const params = {
        userId: userId,
        teamId: teamId,
        messageId: mid.toString(),
        messageContent: content,
        groupId: sessionId,
        messageTime: timestamp,
        realName: name,
        deptName: unitName || "",
        deptId: unitDeptId?.toString() || "",
        uuid: id,
        deviceCode: appRuntimeEnv.registryConfig.machineId || "151ab6d91961b99eb59e45a2fead7097",
        ext: JSON.stringify(ext)
      };
      const [data, error] = await saveMessageTag(params);
      if (data) {
        toast.success(t("tag-successfully"));
      } else {
        toast.warn(error);
      }
    }
  };

  // 语音转文字
  const handleTurnText = async () => {
    props.unLock();
    setShowOperate(false);
    if (!(message as any).url) {
      return;
    }
    Bus.emit(`voice:convertText:loading:${selectedSession.sessionId}:${message.mid}`);
    await voiceToTextFn({
      session: selectedSession,
      message,
      map: voiceMessageMap,
      setMap: setVoiceMessageMap
    });
    await updateVoiceMessageReadStatus(
      message,
      updateSessionMessageMid,
      updateSessionMessagesTimestamp
    );
  };

  // 开启快捷回复
  const handleOpenQuickReply = async () => {
    // 本地改变subType
    updateSessionMessageMid({
      sessionId: message.sessionId,
      sendResult: { body: { ...message, subType: ChatMessageType.QUICK_REPLY } }
    });
    openQuickReplyManual({
      message,
      selectedSession,
      status: QuickReplyStatus.OPEN
    });
  };

  // 发送常用语
  const handleSendReplyEmoji = async (item: any) => {
    setShowOperate(false);
    const msgContentItem = {
      text: item.detail,
      emojiCode: item.id,
      users: [
        {
          pin: currentEmployee.userId,
          app: currentEmployee.app,
          teamId: currentEmployee.teamId,
          clientType: getClientType() === "MAC" ? ClientType.MAC : ClientType.PC,
          timeStamp: new Date().getTime()
        }
      ]
    };
    const hasReply = getMessageEmojiHasReply((message as any)?.msgContent, item, currentEmployee);
    sendReplyEmojiMessage({
      action: hasReply ? MessageExtAction.DELETE : MessageExtAction.ADD,
      session: selectedSession,
      message,
      msgContentItem
    });
  };

  const getMessageOperateNode = () => {
    // 不支持的消息类型 无法进行操作
    const isSupport = checkMessageSupport(message);
    if (!isSupport) {
      return null;
    }
    const { sessionType } = selectedSession;
    // 非单聊 群聊的会话，不支持操作功能
    if (
      ![
        SessionType.GROUP,
        SessionType.SINGLE,
        SessionType.SECRET_SINGLE,
        SessionType.MEETING_GROUP,
        SessionType.LIVE_MEETING_GROUP,
        SessionType.NOTICE,
        SessionType.ORG_BROADCAST,
        SessionType.ORG_NORMAL
      ].includes(sessionType)
    ) {
      return null;
    }

    return (
      <MessageOperate
        updateSessionMessageMid={updateSessionMessageMid}
        currentEmployee={currentEmployee}
        copyOperate={copyOperate}
        undoOperate={revokeOperate}
        adminRevoke={adminRevoke}
        forwardOperate={forwardOperate}
        deleteOperate={deleteOperate}
        destroyOperate={destroyOperate}
        onDropMenuChange={operateMore}
        scheduleOperate={scheduleOperate}
        taskOperate={taskOperate}
        remindOperate={remindOperate}
        selectMoreFn={selectMoreFn}
        message={message}
        unLock={props.unLock}
        selectedSession={selectedSession}
        handleFile={handleFile}
        handleFileTo={handleFileTo}
        handleMsgTag={handleMsgTag}
        undoMsgOperate={revokeMsgOperate}
        turnTextOperate={handleTurnText}
        isRightClick={isRightClick}
        voiceMessageMap={voiceMessageMap}
        groupRosterIdentity={groupRosterIdentity}
        isMeetingChat={isMeetingChat}
        assistantAI={assistantAI}
        openQuickReply={handleOpenQuickReply}
        skipRawMsg={handleSkipRawMsg}
        isSmall={isSmall}
        quickReplys={quickReplys}
        sendReplyEmoji={handleSendReplyEmoji}
        currentFileControl={currentFileControl}
      />
    );
  };

  // 获取AI扩展控制
  // const getAIOperateNode = () => {
  //   if (!isDocFileMessage(message) || !isLLMAI) {
  //     return null;
  //   }
  //   return (
  //     <div className="message-item-control middle">
  //       <div className="item-operate-control">
  //         <AISummaryControl message={message} />
  //       </div>
  //     </div>
  //   );
  // };

  const sendType = useMemo(() => {
    return getMessageSendType(message, currentEmployee, selectedSession);
  }, [message, currentEmployee, selectedSession]);

  useEffect(() => {
    // 设置是否 显示操作控件， 鼠标 hover 为 true
    setShowOperate(showOperateBox);
  }, [showOperateBox]);

  const onSendStatus = (status: MessageStatus) => {
    // 接收控制发送消息组件的状态，只有不是INIT的状态才会接收
    if (status !== MessageStatus.INIT) {
      setSendStatus(status);
    }
  };

  useEffect(() => {
    // 如果消息不是用户发送的消息， 设置为发送状态为 SUCCESS
    if (message && message.status !== MessageStatus.INIT) {
      setSendStatus(MessageStatus.SUCCESS);
    }
  }, [message, showOperate]);

  const canOperate = useMemo(
    (iten?: any) => {
      // 只有 鼠标Hover 和 发送状态为 SUCCESS 的消息 才可以进行消息操作
      return showOperate && sendStatus === MessageStatus.SUCCESS;
    },
    [showOperate, sendStatus]
  );

  const canAIOperate = useMemo(
    (iten?: any) => {
      // 只有  发送状态为 SUCCESS 的消息 才可以进行消息操作
      return showAI && sendStatus === MessageStatus.SUCCESS;
    },
    [sendStatus, showAI]
  );

  if (message.id) {
    return (
      // <div className="message-item-control">
      //   <div className="item-operate-control">{canOperate && getMessageOperateNode()}</div>
      // </div>
      <div className={ hasReachedMax ? "hasReachedMax" : "notReachedMax"}>{canOperate && getMessageOperateNode()}</div>
    );
  }
  return <div />;
}

function mapStateToProps({ chat, user: { userData, teamConfig } }: any) {
  // eslint-disable-next-line prettier/prettier
  const {
    selectedSession,
    currentEmployee,
    allSessionList,
    sessionMessageMap,
    voiceMessageMap,
    saveAsCount,
    quickReplys
  } =
    // eslint-disable-next-line prettier/prettier
    chat as ChatState;
  return {
    selectedSession,
    currentEmployee,
    allSessionList,
    userData: userData ? userData.user : {},
    teamConfig,
    sessionMessageMap,
    voiceMessageMap,
    saveAsCount,
    quickReplys
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    async deleteSessionMessage(data: { message: ChatMessage }) {
      await dispatch({ type: "chat/deleteSessionMessage", payload: data });
    },
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    openCreateRemindModal(data: any) {
      dispatch({ type: "supervise/setCreateModalVisible", payload: data });
    },
    changeSelectMore(data: any) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    },
    updateSessionMessageMid(data: { sendResult: any; sessionId: string }) {
      dispatch({ type: "chat/updateSessionMessageMid", payload: data });
    },
    pushChatMessage(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessage", payload: data });
    },
    pushChatMessageMid(data: { sessionId: string; message: Partial<ChatMessage> }) {
      dispatch({ type: "chat/pushChatMessageMid", payload: data });
    },
    updateSessionMessagesTimestamp(data: { timestamp: number }) {
      dispatch({ type: "chat/updateSessionMessagesTimestamp", payload: data });
    },
    setVoiceMessageMap(payload: boolean) {
      dispatch({ type: "chat/setVoiceMessageMap", payload });
    },
    updateSaveAsCount(payload: number) {
      dispatch({ type: "chat/updateSaveAsCount", payload });
    },
    clearMessageBySession(payload: number) {
      dispatch({ type: "chat/clearMessageBySession", payload });
    },
    setStartMessageId(data: { sMid: number; sText: string }) {
      dispatch({ type: "chat/setStartMessageId", payload: data });
    }
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation("chat")(Control));
